import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { initAnalytics } from "@/seo/seoConfig";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import ServicePage from "@/pages/ServicePage";
import SegmentPage from "@/pages/SegmentPage";
import CityPage from "@/pages/CityPage";
import { SERVICES_DATA } from "@/data/servicesData";
import { SEGMENTS } from "@/data/segmentsData";
import { CITIES_DATA } from "@/data/citiesData";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          {SERVICES_DATA.map((s) => (
            <Route key={s.slug} path={`/services/${s.slug}/`} element={<ServicePage service={s} />} />
          ))}
          {SEGMENTS.map((seg) => (
            <Route key={seg.slug} path={`/segments/${seg.slug}/`} element={<SegmentPage segment={seg} />} />
          ))}
          {CITIES_DATA.map((c) => (
            <Route key={c.slug} path={`/service-areas/${c.slug}/`} element={<CityPage city={c} />} />
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
